import { makeAutoObservable } from "mobx";
import { ACTIONS } from "./utilities";
import ZoomAPI from "../../api/zoom";

const zoomAPI = new ZoomAPI();

const Zoom = class {
    constructor({ store }) {
        const actions = Object.values(ACTIONS);

        for (let i = 0; i < actions.length; i++) {
            const ACTION = actions[i];

            this[`isLoading${ACTION}`] = false;
            this[`error${ACTION}`] = "";
        }

        this.store = store;
        this.settings = null;

        makeAutoObservable(this);
    }

    setIsLoading(name, value) {
        this[`isLoading${name}`] = value;
    }

    setError(name, value) {
        this[`error${name}`] = value;
    }

    setValue(name, value) {
        this[name] = value;
    }

    get hasSettings() {
        return !!this.settings;
    }

    getIsLoading(value) {
        return this[`isLoading${value}`];
    }

    getZoomSettings() {
        this.setIsLoading(ACTIONS.GET_ZOOM_SETTINGS, true);

        zoomAPI
            .getSettings()
            .then((response) => {
                if (response.status === 200) return response.json();
                throw new Error(response.status);
            })
            .then((data) => {
                this.setValue("settings", data);
                this.setIsLoading(ACTIONS.GET_ZOOM_SETTINGS, false);
            })
            .catch(({ message }) => {
                this.setValue("settings", null);
                this.setError(ACTIONS.GET_ZOOM_SETTINGS, message);
                this.setIsLoading(ACTIONS.GET_ZOOM_SETTINGS, false);
            });
    }
};

export default Zoom;
